import { toast } from 'vuetify-sonner';
import { useMenuStore } from '@/stores/menu';
import { useAppStore } from '@/stores/app';
import {MarketType, Platform} from '@/constants';
import { getPlatform } from '@/helpers/getPlatform';

const utils = {

    isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true;
        }

        return false;
    },
    lowerCaseFirstOnlyLetter: (string) => string[0].toLowerCase() + string.slice(1),
    updateBreadcrumbs: function (currentLink) {
        const menuStore = useMenuStore();
        let navMenuItems = getPlatform() === Platform.Tradeball ? menuStore.getNavMenuItems : menuStore.getNavMenuItemsWL;
        let breadCrumbs = [];

        navMenuItems.map(function (menuItem) {
            if (menuItem.subItems) {
                menuItem.subItems.map(function (subMenuItem) {
                    if (subMenuItem.link === currentLink) {
                        breadCrumbs.push({
                            text: menuItem.title,
                            disabled: false,
                        });

                        let title = subMenuItem.breadcrumb ? subMenuItem.breadcrumb : subMenuItem.title;
                        breadCrumbs.push({ text: title, disabled: false });
                    }
                });
            } else if (menuItem.link && menuItem.link === currentLink) {
                breadCrumbs.push({ text: menuItem.title, disabled: false });
            }
        });
        if (!breadCrumbs.length) {
            breadCrumbs.push({ text: currentLink, disabled: false });
        }

        menuStore.setBreadcrumbs(breadCrumbs);
    },


    isEmpty: function (v) {
        return !v && parseInt(v) !== 0;
    },
    isEmail: function (v) {
        return String(v)
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    isNumeric: function (v) {
        return /^-?\d+$/.test(v);
    },

    // showMessage(message, showCloseButton = false, color = 'lightGreenMsg', duration = 3000, top = false, left = false, right = false, icon = null) {
    //     let position = 'bottom-center';
    //     if (top === true && right === true) {
    //         position = 'top-right';
    //     } else if (top === true && left === true) {
    //         position = 'top-left';
    //     } else if (top === true) {
    //         position = 'top-center';
    //     }
    //
    //     let options = {
    //         duration: duration,
    //         position: position,
    //         cardProps: {
    //             color: color,
    //             class: 'tb-toast',
    //             // v-card props
    //         },
    //         prependIcon: icon,
    //     };
    //
    //     if (showCloseButton) {
    //         options.cardProps.class += ' compact';
    //         //here we have small issue with VSonner. To render HTML we can use only description
    //         options.description = message;
    //         message = '';
    //
    //         options['action'] = {
    //             label: 'close',
    //             buttonProps: {
    //                 color: 'white',
    //
    //                 //     icon: 'mdiArrowRightBold',
    //             },
    //         };
    //     }
    //
    //     toast(message, options);
    //     // if (isString(messages)) {
    //     //     messages = {
    //     //         message: messages,
    //     //         showCloseButton: showCloseButton,
    //     //         color: color,
    //     //         timeout: timeout,
    //     //         top: top,
    //     //         bottom: bottom,
    //     //         left: left,
    //     //         right: right,
    //     //         icon: icon,
    //     //         contentClass: '',
    //     //     };
    //     // }
    //     //
    //     // store.commit('AppModule/setMessages', messages);
    // },
    // newBetMessage(message) {
    //     this.showMessage(message, true, 'green', 5000, true, false, true, 'mdiReceiptTextCheckOutline');
    // },
    // orderClosedMessage(message, color) {
    //     this.showMessage(message, true, color, 5000, true, false, true, 'mdiClipboardClockOutline');
    // },
    // failMessage(message) {
    //     this.showMessage(message, false, 'lightRedMsg', 3000, false, false, false, 'mdiAlertCircleOutline');
    // },
    // successMessage(message) {
    //     this.showMessage(message, false, 'lightGreenMsg', 3000, false, false, false, 'mdiCheckboxMarkedCircle');
    // },


    // reload() {
    //     if (this.getPlatform() === Platform.Tradeball) {
    //         window.location.reload();
    //     } else {
    //         let protocol = window.location.protocol + '//';
    //         let domain = window.location.hostname.replace('tradeball.', '');
    //         let url = protocol + domain + '/tradeball' + window.location.pathname;
    //         console.log('Location replace url: ' + url);
    //         window.parent.location.replace(url);
    //     }
    // },
    isSkipJsValidation() {
        return JSON.parse(localStorage.getItem('app'))?.skipJsValidation ?? false;
    },

};
export default utils;
